<template>
	<div class="home-view--banner">
		<btn-edit v-if="editable" :right="230" icon="slider" background="#fff"
			@edit-section="openModal"
		/>


		<div class="banner">
			<section v-for="item in banners" :key="item.id" 
				class="banner__item" 
				:style="{ backgroundImage: `url(${item.image})` }"
				>
					<video-background v-if="item.video!==''"  :src="item.video" class="banner__video">
						<div class="container banner__container">
							<div :class="(item.title||item.subtitle)?'banner__text':'banner__text__clear'">
								<h2>
									{{item.title}}
								</h2>
								<p class="banner__subText">
									{{item.subtitle}}
								</p>
								<a :href="item.url" :target="item.target"  v-if="item.actiontext!==''">
									<button class="cta">{{item.actiontext}}</button>
								</a>
								
							</div>
						</div>				
					</video-background>
				<div v-if="item.video===''" class="container banner__container">
					<div :class="(item.title||item.subtitle)?'banner__text':'banner__text__clear'">
						<h2>
							{{item.title}}
						</h2>
						<p class="banner__subText">
							{{item.subtitle}}
						</p>
						<a :href="item.url" :target="item.target"  v-if="item.actiontext!==''">
							<button class="cta">{{item.actiontext}}</button>
						</a>
						
					</div>
				</div>
			</section>
		</div>
	
		<app-modal 
			:is-visible="isVisibleModal" 
			title="Banner"
			@close-modal="closeModal"
			width="850px"
			height="710px"
		>
			<div>
				<div class="wrapper-modal-image-home">
					<div 
						v-for="(item, index) in banners" 
						:key="index"
						class="modal-images-content">
						<button 
							class="wrapper-icon icon-edit"
							
							@click="editSlider(index)"
						>
							<img 
								src="/static/img/icon-edit.svg" alt=""
								height="12px"
								width="12px">
						</button>	
						<div
						 :style="`background-image: url(${item.image})`"
						 class="image-modal"
						></div>
						<button 
							class="wrapper-icon"
							
							@click="deleteSlider(item.id)"
						>
							<img 
								src="/static/img/icon-close-dark.svg" alt=""
								height="12px"
								width="12px">
						</button>
					</div>
				</div>
				<div class="wrapper-modal-input-home">
					<div class="content-input-home">

						<div class="item-imput-home">	
							<label class="label-modal">
							¿Slideshow Activo?
							<input
							v-model="dataBanner.newbanner"
							type="checkbox" />
							</label>				
						</div>
						<br />
						<div class="item-imput-home">
							<upload-image 
								label-ref="up"
								label-for="image"
								input-id="image"
								@send-image="getImage"
								@delete-image="clearImage"
								:visible-more="false"
								:url-image="sliderNew.image"
							/>
						</div>
						<div class="item-imput-home">
							<upload-image
								label-ref="up"
								label-for="Video"
								input-id="video"
								fileType="urlFile"
								textLabel ="Adjuntar Video (Máximo 15 Mb.)"
								:url-image="sliderNew.video"
								@send-image="getVideo"
								@delete-image="clearVideo"
								@add-image="moreSlider"
								:visible-more="true"		
							/>
						</div>
						<div class="item-imput-home">
							<label 
								for="title"
								class="label-modal">
									Titulo
							</label>
							<input 
								type="text"
								class="form-input"
								id="title"
								v-model="sliderNew.title">
						</div>
						<div class="item-imput-home">
							<label 
								for="subtitle"
								class="label-modal">
								Subtítulo
							</label>
							<input 
								type="text"
								class="form-input"
								id="subtitle"
								v-model="sliderNew.subtitle">
						</div>
						<div class="item-imput-home">
							<label 
								for="subtitle"
								class="label-modal">
								Texto Acción
							</label>
							<input 
								type="text"
								class="form-input"
								id="actiontext"
								v-model="sliderNew.actiontext">
						</div>	
						<div class="item-imput-home">
							<label 
								for="subtitle"
								class="label-modal">
								Url
							</label>
							<input 
								type="text"
								class="form-input"
								id="url"
								v-model="sliderNew.url">
						</div>			
						<div
							class="item-imput-home">
							<label class="label-modal">
								Target 
							</label>
							<select 
								v-model="sliderNew.target"
								id="target"
								class="form-input">
								<option value="">Seleccione un Target</option>
								<option value="_blank">_blank</option>
								<option value="_self">_self</option>
							</select>
						</div>
						<div class="item-imput-home" v-if="false">	
							<label class="label-modal">
							¿Mostrar buscador?
							<input
							v-model="sliderNew.search"
							type="checkbox" />
							</label>				
						</div>									
						<div class="item-imput-home">
							<label 
								for="placeholder"
								class="label-modal">
								Texto de Buscar
							</label>
							<input 
								type="text"
								class="form-input"
								id="placeholder"
								v-model="sliderNew.placeholder">
						</div>
					</div>
					<button 
						class="btn-more-slider"
						:disabled="!sliderNew.image.length > 0"
						@click="moreSlider"
					>
						<img src="/static/img/more-icon.svg" alt="">
					</button>				
				</div>
				<button 
					class="btn-save"
					@click="saveModal"
				>Guardar</button>
			</div>
		</app-modal>
	</div>
</template>

<script>

import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import btnEdit from '@/components/commons/btn-edit';
import appModal from '@/components/commons/app-modal';
import uploadImage from '@/components/commons/upload-image';
import btnLogoff from '@/components/commons/btn-logoff';

function data() {
	return {
		swiperOption: {
			spaceBetween: 0,
			centeredSlides: true,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},
			pagination: {
				el: '.swiper-pagination',
				clickable: true,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		},
		isVisibleModal: false,
		banners: [],
		bannersImage: [],
		dataBanner: [],
		data,
		sliderNew: {
			image: '',
			title: '',
			subtitle: '',
		},
		placeholder: '',
		searchText: '',
	};
}

function created() {
	this.loadData();
}

function closeModal() {
	this.isVisibleModal = false;
}

function openModal() {
	
	this.isVisibleModal = true;
	this.bannersImage = this.banners;
	this.sliderNew = {
		image: '',
		title: '',
		subtitle: '',
		actiontext: '',
		url: '',
		target: '',
		video: '',
		preview: 'https://s3.amazonaws.com/ws-aris/COM-PRU-01/ARQ88/image/video.jpg',
	};
}

async function loadData() {
	try {
		const { company } = this.$store.state;
		this.dataBanner = company.credentialsMail; 
		this.banners = company.credentialsMail.banners.map((item, index) => {
			const newBanners = { ...item };
			newBanners.id = index + 1;
			if (newBanners.video!=='')
			{
				newBanners.image ='https://s3.amazonaws.com/ws-aris/COM-PRU-01/ARQ88/image/video.jpg';
			}
			return newBanners;
		});

		console.log('banner', this.banners)
	} catch (e) {
		if (e.status === 500) {
			this.showError();
		}
	}
}

function numberSlider() {
	return this.banners.length > 1;
}

function getImage(value) {
	this.sliderNew.image = value;
}

function getVideo(value) {
	this.sliderNew.video = value;
}


function clearImage(value){
	this.sliderNew.image = '';
}

function clearVideo(value){
	this.sliderNew.video = '';
}

function moreSlider() {
	//this.bannersImage.push(this.sliderNew);
	this.banners.push(this.sliderNew);
	this.sliderNew = {
		image: '',
		title: '',
		subtitle: '',
		actiontext: '',
		url: '',
		target: '',
		video: '',
		preview: 'https://s3.amazonaws.com/ws-aris/COM-PRU-01/ARQ88/image/video.jpg',
	};
}

async function saveModal() {

	try {
		const { company } = this.$store.state;
		company.credentialsMail = this.dataBanner; 
		company.credentialsMail.banners = this.banners;
		await this.$http.put(`edit/companies/${process.env.APP_CODE}`, company);
		this.showNotification('La edición del slideshow ha sido realizada correctamente.');
		this.fetchCompany();
		this.loadData();
		location.reload();
		this.isVisibleModal = false;
	} catch (e) {
		console.log('error', e);
		this.showError();
	}
}

function deleteSlider(value) {
	this.banners.splice((value - 1), 1);
}

function editSlider(index) {
	this.sliderNew = this.banners[index];
}

function mounted() {
	setTimeout(window.banner, 700);
}

export default {
	data,
	name: 'banner-custom',
	created,
	mounted,
	components: {
		swiperSlide,
		swiper,
		btnEdit,
		btnLogoff,
		appModal,
		uploadImage,
	},
	methods: {
		closeModal,
		openModal,
		loadData,
		getImage,
		getVideo,
		clearVideo,
		moreSlider,
		saveModal,
		deleteSlider,
		editSlider,
	},
	computed: {
		numberSlider,
	},
};
</script>

<style lang="scss" scoped>

[class^="icon-"], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'icomoon' !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;

  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body{
	margin: 0;
	font-weight: 400;
	font-size: 15px;
	line-height: 1.667;
	color: #363636;
}
@media screen and (min-width: 768px){
h1, h2{
		font-size: 290%
	}
}
.container{
	position: relative;
	max-width: 1200px;
	margin-left: auto;
	margin-right: auto;
	padding-left: 15px;
	padding-right: 15px;
}
.container--sm{
		max-width: calc(1200px * 0.8);
	}
.container--xs{
		max-width: calc(1200px * 0.6);
	}

@media screen and (min-width: 1024px){
    .block-flex {
        display: flex;
    }
    .container-head--xs {
        /* max-width: calc(1200px * 0.6); */
        min-width: 1024px;
    }
    .block-flex > div:first-child {
        width: 50%;
    }
    
}
.container--xs.color {
    background-color: #f1f1f1;
    padding-top: 45px;
    padding-bottom: 68px;
}
.container--xs.form_point_send {
    max-width: inherit;
}
.container--xs.form_point_send h3 {
    font-size: x-large;
    font-weight: bold;
}
.cta{
  	-webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    display: inline-block;
    cursor: pointer;
    background-color: #001d32;
    border: none;
    border-radius: 0.2em;
    color: #fff;
    padding: 0.8em 30px;
    margin-bottom: 2em;
    font-size: 120%;
    line-height: 1.4;
    -webkit-transition: background-color .4s,color .4s,border .4s;
    transition: background-color .4s,color .4s,border .4s;
}
@keyframes bannerAnimationText{
    0%{
        transform: translateX(-100%);
        opacity: 0;
    }
    100%{
        transform: translateX(0);
        opacity: 1;
    }
}
.banner.slick-dotted{
        margin-bottom: 0;
    }
.banner .slick-prev {
        left: 30px;
        z-index: 100;
        transform: scale(1.5);
    }
.banner .slick-next {
        right: 30px;
        z-index: 100;
        transform: scale(1.5);
    }
.banner__item{
        overflow: hidden;
        height: calc(100vh - 50px) !important;
        background-size: cover;
        background-position: center center;
    }
	
@media screen and (min-width: 1024px){
.banner__item{
        height: 100vh !important
    }
}
.banner__container{
        height: 100%;
        display: flex;
        align-items: center;
    }

.banner__text__clear
{
	background-color: transparent;
	margin-top: 60px;
    margin-left: 20px;
    width: 90%;
}
.banner__text{
        margin-top: 60px;
        margin-left: 20px;
        width: 90%;
        transform: translateX(-100%);
        opacity: 0;
        transition: transform 1200ms 1500ms, opacity 1000ms 1500ms;
        background-color: #00000055;
        padding: calc(15px * 2 ) calc(15px * 2.5 );
}
@media screen and (min-width: 1024px){
.banner__text{
            margin-top: 0;
			background-color: #00000055;
			padding: 7em 2em;
            width: 40%
    }
.banner__text__clear{
		margin-top: 0;
		background-color: transparent;
		padding: 7em 2em;
		width: 40%
	}
}
.banner h2{
	color: #003f72;
	font-size: 150%;
}
@media screen and (min-width: 768px){
.banner h2{
            font-size: 200%
    	}
}
.banner .slick-dots{
	width: auto;
	left: 20px;
	bottom: 30px;
}
@media screen and (min-width: 1024px){
.banner .slick-dots{
            top: 50%;
            bottom: auto;
            transform: translateY(-50%);
            z-index: 100;
    }
}
.banner .slick-dots li{   
	margin: 0 5px;
}
@media screen and (min-width: 1024px){
.banner .slick-dots li{
		display: block;
		margin: 25px 0;
	}
}
.banner .slick-dots li.slick-active button::before{
	transform: scale(0.7);
	background-color: #003f72;
}
.banner .slick-dots button::before{
	color: transparent !important;
	opacity: 1 !important;
	border: solid 3px #003f72;
	border-radius: 50%;
	transform: scale(0.4);
	transition: background-color 300ms, transform 300ms;
}
.banner .slick-active .banner__text{
	transform: translateX(0);
	opacity: 1;
}
@media screen and (min-width: 768px){
.banner .slick-active .banner__text{
		transform: translateY(0)
	}
}
.text-left{
    text-align: left;
}
.text-align-center {
    text-align: center;
}
.banner h2 {
    color: #fff;
    font-size: 150%;
    line-height: 1.4em;
    font-weight: bolder;
}
.banner__subText {
    color: #fff;
    font-size: 100%;
    line-height: 1.6em;
    padding: 2em 0em;
    font-weight: 300;
}
.search {
	padding-bottom: -100px;
}
.banner__video
{
	height: 100%;
    display: flex;
    align-items: center;
}
.wrapper-modal-image-home {
	@include display-flex();
	border-bottom: 1px solid map-get($colors, text-alert) !important;
	flex-wrap: wrap;
	justify-content: space-around;
	margin-bottom: 10px !important;
	padding-bottom: 28px !important;

	.image-modal {
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		height: 52px;
		width: 83px;
	}

	.modal-images-content {
		@include flex-center();
		position: relative;
	}

	.wrapper-icon {
		@include flex-center();
		@include box-shadow(0, 2px, 8px, 0, rgba(0, 0, 0, 0.5));
		@include border-radius(50%);
		background: map-get($colors, white);
		height: 35px;
		margin-left: -12px;
		width: 35px;
	}

	.icon-edit {
		margin-right: -12px;
		z-index: 7;
	}
}
.wrapper-modal-input-home {
	@include display-flex();
	justify-content: space-around;

	.content-input-home {
		width: 90%;
	}
}
.btn-more-slider {
	@include flex-center();
	@include border-radius(5px);
	background-color: map-get($colors, base) !important;
	height: 30px;
	margin-top: 33px;
	width: 30px;
}
.slide-title {
	@include font-size(24);
	@include font-maison-book();
	margin: 0;
	margin-bottom: 10px;
	text-align: center;
  width: 319px;
  text-shadow: 0 0 10px rgba(0, 0, 0, .9);
}
.bold {
	@include font-maison-bold();
}
.sub-title-header {
  @include font-size(16);
  text-shadow: 0 0 10px rgba(0, 0, 0, .9);
}
.home-banner-input {
	@include font-size(16);
	background-color: rgba(map-get($colors, black), .13);
	border: 1px solid map-get($colors, white);
	border-radius: 12px;
	color: map-get($colors, white);
	height: 50px;
  padding-left: 22px;
	margin: 0;
  &::-webkit-input-placeholder {
    color: map-get($colors, white);
  }
  &::-moz-placeholder {
    color: map-get($colors, white);
  }
  &:-ms-input-placeholder {
    color: map-get($colors, white);
  }
  &:-moz-placeholder {
    color: map-get($colors, white);
  }
}
.image-buscador {
		position: absolute;
    right: 19px;
}
.home-banner-wrapper-title {
		@include display-flex();
		flex-direction: column;
		align-items: center;
}
@media screen and (min-width: 1024px) {
	.form-input {
		border: none;
		outline: none;
		border: 1px solid map-get($colors, white);
	}

	.home-banner-input {
		border: 1px solid map-get($colors, white);
		margin-left: 15px;
	}

	.home-banner-search-wrapper {
		top: 56vh;
	}

	.home-banner-wrapper-title {
		align-items: flex-start;
		margin-left: 15px;
	}
	
	.logo-product-aris {
		height: 91px;
		width: 370px;
	}
	.slide-title {
		@include font-size(36);
		line-height: 36px;
		text-align: left;
		width: 478px;
	}
	.sub-title-header {
		@include font-size(19);
		margin-right: 66%;
		position: relative;
		width: 285px;
	}
}
@media screen and (min-width: 1200px){
	.home-banner-search-wrapper {
		top: 60vh;
	}
}

.btn-save {
	background: map-get($colors, black-dark);
	color: #fff;
	display: block;
	margin: 42px auto;
	padding: 13px 35px;
}

</style>


// WEBPACK FOOTER //
// src/components/home/banner-custom.vue